
// see https://docs.bugsnag.com/platforms/javascript/reporting-handled-errors/
export const severity = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'error'
};

export const notifyOptionKeys = {
  SEVERITY: 'severity'
};
